export function normalizeBuilderData(data) {
  const { records, count, page, total } = data;
  const meta = { count, page, total };

  const tableData = records.map((record) => ({
    id: record.id,
    name: record.name,
    description: record.description,
    // isDefault: record.isDefault,
  }));

  const modalData = records.map((record) => ({
    id: record.id,
    name: record.name,
    description: record.description,
    // isDefault: record.isDefault,
  }));

  return { tableData, modalData, meta };
}
